import React from 'react';
import PropTypes from 'prop-types';

const RadioOption = ({
  className, name, value, label, checked, disabled, onChange, ...rest
}) => (
  <label className={`form-radio ${className || ''}`} {...rest}>
    <input
      type="radio"
      name={name}
      value={value}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
    <span
      className="form-radio-label"
    >{label}</span>
  </label>
);
RadioOption.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default RadioOption;



// WEBPACK FOOTER //
// ./spa/Components/Form/RadioOption.jsx